import { render } from "./HeaderSettingsPanel.vue?vue&type=template&id=bf2e22c4&scoped=true&ts=true"
import script from "./HeaderSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./HeaderSettingsPanel.vue?vue&type=script&lang=ts"

import "./HeaderSettingsPanel.vue?vue&type=style&index=0&id=bf2e22c4&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2e22c4"]])

export default __exports__